import styled from 'styled-components'

export const CardContainer = styled.div`
  cursor: ${(props) => (props.cursor ? 'pointer' : 'default')};
  display: table-cell;
  text-align: -webkit-center;
  width: 100%;
`

export const Container = styled.div`
  background-color: var(--white);
  width: 100%;
  height: 100%;
  border-radius: 20px;
  display: flex;
  justify-content: center;
`

export const TextBottom = styled.div`
  font-family: 'Brevia Light Italic';
  font-size: clamp(38px, 10vw, 56px);
  line-height: 50px;
  margin: 0;
  position: absolute;
  left: -8px;
  bottom: -9px;
  color: var(--white);
  text-align: left;
`

export const NameInfo = styled.p`
  color: var(--black);
  font-family: 'Noto Sans Thai Bold';
  font-size: clamp(24px, 2.5vw, 34px);
  line-height: 38px;
  margin-top: 20px;
  margin-bottom: 0;


  @media only screen and (min-width: 1440px) {
  margin-top: 25px;

    margin-bottom: 20px;
  }
`

export const Card = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  padding-bottom: 100%;
  perspective: 1000px;

  .card-cover {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%);
    background-size: cover;
    perspective-origin: 50% 50%;
    transform-style: preserve-3d;
    transform-origin: top center;
    will-change: transform;
    transform: skewX(0.001deg);
    transition: transform 0.35s ease-in-out;

    // Gloss

    &::after {
      display: block;
      content: '';
      position: absolute;
      z-index: 100;
      top: 0;
      left: 0;
      width: 100%;
      height: 120%;
      /* background: linear-gradient(
        226deg,
        rgba(255, 255, 255, 0.4) 0%,
        rgba(255, 255, 255, 0.4) 35%,
        rgba(255, 255, 255, 0.2) 42%,
        rgba(255, 255, 255, 0) 60%
      ); */
      transform: translateY(-20%);
      will-change: transform;
      transition: transform 0.65s cubic-bezier(0.18, 0.9, 0.58, 1);
    }
  }

  &:hover .card-cover {
    transform: rotateX(7deg) translateY(-6px);

    &::after {
      transform: translateY(0%);
    }
  }

  // Shadows

  &::before {
    display: block;
    content: '';
    position: absolute;
    top: 5%;
    left: 5%;
    width: 90%;
    height: 90%;
    background: rgba(#000000, 0.5);
    box-shadow: 0 6px 12px 12px rgba(#000000, 0.4);
    will-change: opacity;
    transform-origin: top center;
    transform: skewX(0.001deg);
    transition: transform 0.35s ease-in-out, opacity 0.5s ease-in-out;
  }

  &:hover::before {
    opacity: 0.6;
    transform: rotateX(7deg) translateY(-6px) scale(1.05);
  }
`
